import type { GAParams } from 'admin/components/pages/Story/CardEditor/Inspector/GASettings/types';

export function parseGAParams(paramsStr: string): GAParams {
	try {
		const parsedParams = JSON.parse(paramsStr);
		return {
			actionName: parsedParams.actionName,
			params: Array.isArray(parsedParams.params) ? parsedParams.params : [],
		};
	} catch {
		return {
			actionName: paramsStr,
			params: [],
		};
	}
}
